<ng-container *ngIf="landingPageContent$ | async as result">
  <ng-container *ngIf="!result.loading; else loader">
    <ng-container *ngIf="!result.error; else error">
      <ng-container *ngIf="result.content.banner">
        <epc-banner
          *ngIf="!result.error; else error"
          [banner]="result.content.banner"
          class="mb-2"
          (linkClick)="
            onLinkClick(
              $event.url,
              promotionSource.Link,
              $event.position,
              $event.link
            )
          "
        ></epc-banner>
      </ng-container>
      <div
        *ngFor="let row of result.content.rows"
        [ngClass]="row.classes ?? 'tile-row d-flex w-100 px-2'"
      >
        <epc-tile
          *ngFor="let tile of row.tiles; let index = index"
          [tile]="tile"
          [dynamicPanel]="
            tile.panelContent$ ? (tile.panelContent$ | async) : null
          "
          [ngClass]="tile.classes"
          (tileClick)="
            onLinkClick(
              $event,
              promotionSource.Image,
              tilesIndexAddition + index,
              tile
            )
          "
        ></epc-tile>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #error>
  <atx-page-not-found></atx-page-not-found>
</ng-template>

<ng-template #loader>
  <div class="loader my-5 d-flex justify-content-center align-items-center">
    <fa-icon [icon]="['fas', 'spinner']" [spin]="true" [pulse]="true"></fa-icon>
  </div>
</ng-template>
